import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { Button, Form, Table, Spin, Input, Select } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import { searchProductWW } from "../../redux/actions/searchProductWW.action";
import notification from "../../utils/notification";
import { SearchOutlined, FilterFilled } from "@ant-design/icons";
import Swal from "sweetalert2";
import { sendProductWW } from "../../redux/actions/sendProductToBergenWW.action";
import * as XLSX from "xlsx";

const StyleMasterToBergen = () => {
  TabTitle("WW Style Master to Bergen");
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const dispatch = useDispatch();
  const token = ReadCookie("token");
  const [controlSheet, setControlSheet] = useState([]);
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { controlLog } = useSelector((state) => state);
  const [excelData, setExcelData] = useState([]);

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "Style",
      dataIndex: "ProductCode",
      key: "ProductCode",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              autoFocus
              allowClear
              className="pop-search-gen pop-170"
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) =>
        record.ProductCode.toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      sorter: (a, b) => {
        return a.ProductCode - b.ProductCode;
      },
    },

    {
      title: "Color",
      dataIndex: "Washtype",
      key: "Washtype",
    },
    {
      title: "Size",
      dataIndex: "productSize",
      key: "productSize",
    },
    {
      title: "UPC",
      dataIndex: "UPC",
      key: "UPC",
    },
    {
      title: "Description",
      render: (text, record) => {
        return record.style + " " + (record.Cut === "N/A" ? "" : record.Cut);
      },
    },
    {
      title: "Price",
      render: (text, record) => {
        return <>{numeral(record.Retail_Rate).format("0,00")}</>;
      },
      align: "right",
    },
    {
      title: "HsCode",
      dataIndex: "HsCode",
      key: "HsCode",
    },
    {
      title: "Custom Description",

      render: (text, record) => {
        return record.Type.toUpperCase() + " " + record.commodity;
      },
    },
    {
      title: "UPC2",
      dataIndex: "UPC2",
      key: "UPC2",
    },
    {
      title: "Country of Origin",
      dataIndex: "COO",
      key: "COO",
      render: (text, record, index) => (
        <Input
          size="small"
          value={record.COO}
          onChange={(e) => {
            const temp = [...controlSheet];
            temp[index].COO = e.target.value;
            setControlSheet(temp);

            downloadExcelFileData(temp);
          }}
        />
      ),
    },
    {
      title: "Part Number",
      render: (text, record) => {
        return record.ProductCode + "-" + record.productSize;
      },
    },
  ];

  const onFinish = async () => {
    await form
      .validateFields()
      .then((values) => {
        if (!values.sku) {
          Swal.fire({
            icon: "error",
            title: "OOPS",
            text: `Please Insert SKU.`,
            confirmButtonColor: "#3c4b58",
          });
        } else {
          setLoading(true);
          dispatch(searchProductWW(token, values, values.country))
            .then((res) => {
              setLoading(false);
              if (res?.payload?.data) {
                setLoading(false);
                // setControlSheet(res?.payload?.data);
                // downloadExcelFileData(res?.payload?.data);
                const updatedData = res?.payload?.data.map((item) => ({
                  ...item,
                  COO: values.country,
                }));

                setControlSheet(updatedData);
                downloadExcelFileData(updatedData);
              }
            })
            .catch((err) => {
              setLoading(false);
            });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  // const onSearch = async () => {};

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          ProductCode: v.ProductCode,
          Washtype: v.Washtype,
          style: v.style,
          Cut: v.Cut,
          productSize: v.productSize,
          UPC: v.UPC,
          Description: v.style + " " + v.Cut,
          Retail_Rate: v.Retail_Rate,
          HsCode: v.HsCode,
          "Commodity Description": v.commodity,
          COO: v.COO,
          Type: v.Type,
          commodity: v.commodity,
          HsCode: v.HsCode,
          MSRP: v.Retail_Rate,
          UPC2: v.UPC2,
          PartNumber: v.ProductCode + "-" + v.productSize,
        };
      })
    );
  }
console.log(controlSheet, 'controlSheet');

  const onSubmit = async () => {
    await form
      .validateFields()
      .then((values) => {
        if (controlSheet?.length === 0) {
          Swal.fire({
            icon: "error",
            title: "OOPS",
            text: `Please Insert SKU.`,
            confirmButtonColor: "#3c4b58",
          });
        } else {
          setLoading(true);
          const payload = {
            ...values,
            products: controlSheet,
          };

          console.log("payload", payload);
          dispatch(sendProductWW(token, payload)).then((res) => {
            setLoading(false);
            if (res.type === "GET_SEND_PRODUCT_WW_SUCCESS") {
              notification("success", "Style Send Successfully");
            }

            downloadExcelFileData(res?.payload?.data);
          });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      const data = event.target.result;

      const workbook = XLSX.read(data, {
        type: "binary",
      });

      const sheetName = workbook.SheetNames[0];

      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      console.log(jsonData);

      setControlSheet(jsonData);

      downloadExcelFileData(jsonData);
    };

    reader.readAsBinaryString(file);
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Send WW Style Master to Bergen"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="formProduct p-2 d-flex align-items-baseline">
              <Form
                onFinish={onFinish}
                form={form}
                name="control-hooks"
                style={{ width: "40%" }}
              >
                <div className="container-fluid pbpx-5 ptpx-5">
                  <Brow>
                    <Bcol lg={6} xl={6} xxl={6}>
                      <div>
                        <div className="relative">
                          <Form.Item
                            name="sku"
                            label="SKU"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input size="small" className="styleInput" />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={6} xxl={6}>
                      <Form.Item
                        name="country"
                        label="Country"
                        labelAlign="left"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValue="PAKISTAN"
                      >
                        <Select size="small">
                          <Select.Option value="PAKISTAN">
                            PAKISTAN
                          </Select.Option>
                          <Select.Option value="CHINA">CHINA</Select.Option>
                        </Select>
                      </Form.Item>
                    </Bcol>
                    {/* <Bcol lg={6} xl={4} xxl={3}>
                      <div>
                        <div className="relative">
                          <Form.Item
                            labelAlign="left"
                            labelCol={{ span: 2 }}
                            wrapperCol={{ span: 2 }}
                          >
                            <Button
                              type="primary"
                              className=""
                              onClick={onSearch}
                            >
                              <span className="px-2">Search</span>
                            </Button>
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol> */}
                  </Brow>
                </div>
              </Form>
              <Button
                htmlType="submit"
                type="primary"
                className="ant-btn ant-btn-primary mrpx-20"
                onClick={onFinish}
              >
                <span className="px-2">Search</span>
              </Button>
              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={handleExcelUpload}
              />

              {controlSheet.length > 0 && (
                <Button
                  htmlType="submit"
                  type="primary"
                  className="ant-btn ant-btn-primary mrpx-20 mb-2"
                  style={{ marginLeft: "auto" }}
                  onClick={onSubmit}
                  disabled={loading}
                >
                  <span className="px-2">Send</span>
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10 }}>
        {loading ? (
          <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
            <Spin size="large" />
          </div>
        ) : controlSheet.length > 0 ? (
          <>
            <Table
              title={() => (
                <CSVLink
                  filename={"StyleMaster.csv"}
                  data={excelData}
                  onClick={() => {}}
                >
                  Download Excel
                </CSVLink>
              )}
              ref={tableRef}
              size="small"
              bordered={false}
              type="company"
              perPage={15}
              scroll={{ x: "max-content" }}
              dataSource={controlSheet}
              columns={columns}
              loading={controlLog.loading}
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 100,
                pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
              }}
            />
          </>
        ) : (
          <div
            style={{
              backgroundColor: "#CCCCCC",
              borderWidth: "1pt",
              borderStyle: "Dashed",
              fontWeight: "bold",
              height: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            No record(s)
          </div>
        )}
      </div>
    </div>
  );
};

export default StyleMasterToBergen;
